import * as CryptoJS from 'crypto-js'

const KEY = 'higia'

const encrypt = (value, isObj) => {
    value = isObj ? JSON.stringify(value) : value
    return CryptoJS.AES.encrypt(value, KEY).toString()
}

const decrypt = (encryptedParam) => {
    return CryptoJS.AES.decrypt(encryptedParam, KEY).toString(CryptoJS.enc.Utf8)
}

export default {
    encrypt,
    decrypt,
}
